import { Injectable } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { ProjectService } from '@mirage-projects/cw-commons';
import { CatalogObjectTypesEnum, Layer, Project, ProjectData } from '@mirage-projects/cw-models';

import { ObjectBrowserSelectionService } from '../../object-browser/selection.service';

/** This service manages the creation of the project */
@Injectable()
export class CreateProjectContentService {
    constructor(
        private projectService: ProjectService,
        private selectionService: ObjectBrowserSelectionService
    ) {}

    /**
     * Creates the project based on the input data and, if there are layers selected, adds them to the created project
     * @param projectData The required data to create the project
     * @returns the project created
     */
    async createProject(projectData: ProjectData, shouldAddLayers = false): Promise<Project> {
        try {
            const project = await firstValueFrom(this.projectService.create(projectData));

            if (shouldAddLayers) {
                const layerIds = this.getCompleteSelectedLayers()?.map((layer) => layer.id);

                if (layerIds?.length) {
                    await firstValueFrom(this.projectService.addLayers(project.id, layerIds));
                }
            }

            return project;
        } catch {
            throw new Error('CREATE_PROJECT.ERROR');
        }
    }

    /**
     * gets the selected layers that are not incomplete
     * @returns array of layers
     */
    getCompleteSelectedLayers(): Layer[] | undefined {
        return (this.selectionService.getSelectedElements(CatalogObjectTypesEnum.layers) as Layer[])?.filter((layer) => !layer.incomplete);
    }
}
